import React from 'react'
import styled from 'styled-components'
import { BridalPlanProps } from '../../../../BridalPlan.types'
import { styleTheme } from '../../../../../../style/theme'
import { getPrimaryColor } from '../../../../../../style/utils'

type ContentsProps = {
  className?: string
  plan: BridalPlanProps | undefined
  primaryColor?: string
}

export const Contents = (props: ContentsProps) => {
  return <StyledComponent {...props} />
}

const Component: React.FC<ContentsProps> = ({ plan, className, primaryColor }) => {
  return (
    <>
      <div className={className}>
        <h2>プランに含まれるもの</h2>
        <table className="tb">
          <tbody>
            {plan?.bridalPlanContents &&
              plan?.bridalPlanContents?.length > 0 &&
              plan.bridalPlanContents.map((content, i) => (
                <tr key={i}>
                  <th>{content.name}</th>
                  <td className="check-cell">{content.name && content.isActive ? '◯' : '-'}</td>
                  <td className="content-cell">{content.description}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  )
}

const StyledComponent = styled(Component)`
  > h2 {
    font-family: 'Noto Sans JP', sans-serif;
    font-size: 18px;
    font-weight: bold;
    line-height: 27px;
    padding: 20px 0 0;
    color: ${getPrimaryColor};
    margin: 35px 20px 20px 0;
    border-top: 1px dotted ${styleTheme.colors.gray.baseLight};
  }

  > table {
    color: ${styleTheme.colors.black};
    font-family: 'Noto Sans JP', sans-serif;
    font-size: 14px;
    line-height: 23.8px;

    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    border: 1px solid ${styleTheme.colors.gray.baseLight};
    margin: 0;
    padding: 0;

    > tbody {
      > tr {
        height: 47px;

        > th {
          background-color: ${styleTheme.colors.gray.light};
          width: 160px;
          font-weight: lighter;
          border: 1px solid ${styleTheme.colors.gray.baseLight};
        }

        > td {
          margin: 0;
          border: 1px solid ${styleTheme.colors.gray.baseLight};
        }

        .check-cell {
          width: 102px;
          text-align: center;
        }

        .content-cell {
          padding-left: 8px;
          width: 648px;
        }
      }
    }
  }
`
